import { startTransition, useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { useParams } from 'react-router-dom';
import { TemplatePlaceholderRowProps } from '../components/document-content/components/TemplatePlaceholderRow/types';
import { AITemplatePlaceholderModel } from '../../../models/ai.template.placeholder.model';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { updatePlaceholder } from '../../../slices/template-placeholders/templatePlaceholdersSlice';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useErrorMessage } from '../../../common/hooks/useErrorMessage';

export const useTemplatePlaceholderRow = ({
  id,
  data,
  documentHTMLId,
}: TemplatePlaceholderRowProps) => {
  const currentUser = useAppSelector(selectUser);
  const { t } = useTranslation();
  const { getErrorMessage } = useErrorMessage();
  const dispatch = useAppDispatch();
  const { documentId } = useParams();
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [field, setField] = useState<string>(data.field);
  const [value, setValue] = useState<string>(data.value);
  const [placeholder, setPlaceholder] = useState<string>(data.placeholder);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [placeholderIdValue, setPlaceholderIdValue] = useState<number>(id ?? 0);
  const [deletePlaceholderMessageVisible, setDeletePlaceholderMessageVisible] =
    useState<boolean>(false);
  const request = () => {
    setPendingStatus(true);
    const data = {
      data: { field, value, placeholder },
      //[contractGenerated ? 'document_contract' : 'document_upload']: documentUploadId,
      document_upload: Number(documentId),
      document_upload_html: documentHTMLId,
      user: currentUser.id,
    };
    if (id) {
      return dispatch(updatePlaceholder({ data, id }));
    } /*else {
      return NWClient.post('document-template-placeholder', data);
    }*/
  };
  const handleSavePlaceholder = () => {
    if (editMode || !placeholderIdValue) {
      request()!
        .unwrap()
        .then((response) => {
          const res = response as AITemplatePlaceholderModel;
          toast.success(
            placeholderIdValue
              ? t('messages.templatePlaceholderUpdated')
              : t('messages.templatePlaceholderCreated')
          );
          setEditMode(false);
          setPlaceholderIdValue(res.id);
        })
        .catch((error) => {
          toast.error(getErrorMessage(error));
        })
        .finally(() => setPendingStatus(false));
    } else {
      setEditMode(true);
    }
  };
  const setValues = useCallback(() => {
    setField(data.field);
    setValue(data.value);
    setPlaceholder(data.placeholder);
  }, [data]);

  useEffect(() => {
    startTransition(() => setValues());
  }, [setValues]);

  return {
    field,
    setField,
    value,
    setValue,
    placeholder,
    setPlaceholder,
    editMode,
    setEditMode,
    placeholderIdValue,
    deletePlaceholderMessageVisible,
    setDeletePlaceholderMessageVisible,
    pendingStatus,
    setPendingStatus,
    handleSavePlaceholder,
  };
};
